// Copyright 2023 Sorama B.V.

import { Unit, UnitType } from "units/Unit";
import { CompositeUnit } from "./CompositeUnit";
import { Currency } from "./Currency";

export class Volume extends UnitType {
    public static override typeName = "Volume";

    public static gallons: Unit = new Unit("gal", 0.264172e-3, Volume);
    public static cubicMeters: Unit = new Unit("m³", 1, Volume, {
        aliases: ["m3", "cubic meter", "cubic metre", "cubic meter (SI)"],
    });
    public static milliLiters: Unit = new Unit("mL", 1e-6, Volume);
    public static hectoLiter: Unit = new Unit("hL", 1e-1, Volume);
    public static kiloLiter: Unit = new Unit("kL", 1, Volume);
    public static liters: Unit = new Unit("L", 1e-3, Volume, { aliases: ["liter", "litre"] });
    public static cubicFeet: Unit = new Unit("SCF", 0.0283168, Volume);

    public static metricVolumeUnits: Unit[] = [Volume.cubicMeters, Volume.milliLiters, Volume.kiloLiter, Volume.liters];
    public static imperialVolumeUnits: Unit[] = [Volume.gallons, Volume.cubicFeet];
}

export class VolumeCost extends UnitType {
    public static typeName = "Volume price";

    public static euroPerLiter: CompositeUnit = new CompositeUnit(Currency.EUR, Volume.liters, VolumeCost, {
        aliases: ["EUR/L", "EUR/liter"],
    });
    public static euroPerKiloLiter: CompositeUnit = new CompositeUnit(Currency.EUR, Volume.kiloLiter, VolumeCost, {
        aliases: ["EUR/1000L"],
    });
    public static usdPerCubicFoot: CompositeUnit = new CompositeUnit(Currency.USD, Volume.cubicFeet, VolumeCost, {
        aliases: ["USD/SCF", "USD / cubic foot"],
    });
}
